import {Http} from "@angular/http";
import {Injectable} from "@angular/core";
import {contextPath} from "site";
import {OrgService} from "./shared/org.service";

const apiURL = `${contextPath}/api/`;
const connectedCockpitDeviceURL = `${apiURL}connected-cockpit-devices`;

@Injectable()
export class ConnectedCockpitDeviceService {

	constructor(
		private http: Http,
		private orgService: OrgService
		) {}

	addConnectedCockpitDeviceToCustomerAircraft(
		customerAircraftUuid: string,
		deviceModelId: number,
		customerGuid: string) {

		let params = {
			customerAircraftUuid,
			deviceModelId,
			customerGuid
		};

		if(customerGuid == null){
			params.customerGuid = undefined
		}

		return this.http.post(connectedCockpitDeviceURL, null, {params, headers: this.orgService.contextHeader});
	}

	removeConnectedCockpitDeviceFromCustomerAircraft(
		customerAircraftUuid: string,
		deviceModelId: number,
		customerGuid: String = null) {

		let params;
		if (customerGuid != null) {
			params = {
				customerAircraftUuid,
				deviceModelId,
				customerGuid,
			};
		} else {
			params = {
				customerAircraftUuid,
				deviceModelId,
			};
		}
		return this.http.delete(connectedCockpitDeviceURL, {params, headers: this.orgService.contextHeader});
	}
}
